
import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import API_BASE_URL from "../config/api";
import "../styles/Login.css";

function Login() {

    const navigate = useNavigate();

    const [showPassword, setShowPassword] = useState(false);

    const [email, setEmail] = useState("");

    const [password, setPassword] = useState("");

    const [loading, setLoading] = useState(false);


    const handleSubmit = async (e) => {

        e.preventDefault();


        if (!email.trim()) {

            Swal.fire({
                icon: "warning",
                title: "Email Required",
                text: "Please enter your email address."
            });

            return;
        }


        if (!password.trim()) {

            Swal.fire({
                icon: "warning",
                title: "Password Required",
                text: "Please enter your password."
            });

            return;
        }


        try {

            setLoading(true);



            console.log("Email:", email);



            const response = await fetch(
                `${API_BASE_URL}/admin/login`,
                {
                    method: "POST",

                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    },

                   

                    credentials: "include",

                    body: JSON.stringify({
                        email: email.trim(),
                        password: password
                    })
                }
            );


            console.log("Response Status:", response.status);

            console.log("Response OK:", response.ok);

            console.log(
                "Content-Type:",
                response.headers.get("content-type")
            );



            const responseText = await response.text();


            console.log("Raw Laravel Response:");

            console.log(responseText);


            let data = {};

            try {

                data = JSON.parse(responseText);

            } catch (jsonError) {

                console.error(
                    "JSON Parse Error:",
                    jsonError
                );


                Swal.fire({
                    icon: "error",
                    title: "Invalid API Response",
                    text: "Laravel ने valid JSON response नहीं भेजा।"
                });

                return;
            }


            if (data.admin) {

                console.log(
                    "✅ ADMIN DATA:"
                );

                console.log(data.admin);

            }


            /*
            |--------------------------------------------------------------------------
            | Login Failed
            |--------------------------------------------------------------------------
            */

            if (!response.ok) {

                Swal.fire({
                    icon: "error",
                    title: "Login Failed",
                    text:
                        data.message ||
                        "Invalid email or password."
                });

                return;
            }


            



            await Swal.fire({

                icon: "success",

                title: "Login Successful",

                text:
                    "Welcome to HomeoAdda Admin Panel.",

                timer: 1500,

                showConfirmButton: false

            });

            navigate("/dashboard");


        } catch (error) {

            console.error(
                "================================"
            );

            console.error(
                "FETCH ERROR:"
            );

            console.error(error);

            console.error(
                "================================"
            );


            Swal.fire({

                icon: "error",

                title: "Connection Error",

                text:
                    error.message ||
                    "Unable to connect with server."

            });


        } finally {

            setLoading(false);

        }

    };


    return (
        <>

            <Helmet>

                <title>
                    Admin Login | HomeoAdda
                </title>

            </Helmet>
            <div className="login-page">


            <div className="bg-circle bg-circle-1"></div>

            <div className="bg-circle bg-circle-2"></div>


            <div className="login-card">


                <div className="login-header">


                    <div className="logo-box">
                        HA
                    </div>


                    <h2>
                        HomeoAdda Admin
                    </h2>


                    <p>
                        Welcome Back! Please login to continue
                    </p>


                </div>


                <form onSubmit={handleSubmit}>


                    <div className="mb-4">


                        <label>
                            Email Address
                        </label>


                        <input
                            type="email"

                            className="form-control custom-input"

                            placeholder="Enter your email"

                            value={email}

                            onChange={(e) =>
                                setEmail(e.target.value)
                            }

                        />


                    </div>


                    <div className="mb-4">


                        <label>
                            Password
                        </label>


                        <div className="password-wrapper">


                            <input

                                type={
                                    showPassword
                                        ? "text"
                                        : "password"
                                }

                                className="form-control custom-input"

                                placeholder="Enter your password"

                                value={password}

                                onChange={(e) =>
                                    setPassword(e.target.value)
                                }

                            />


                            <button

                                type="button"

                                className="eye-btn"

                                onClick={() =>
                                    setShowPassword(
                                        !showPassword
                                    )
                                }

                            >

                                {
                                    showPassword
                                        ? <FaEyeSlash />
                                        : <FaEye />
                                }

                            </button>


                        </div>


                    </div>


                    <div className="login-options">


                        <div>

                            <input
                                type="checkbox"
                            />

                            {" "}Remember Me

                        </div>


                        <a href="/">
                            Forgot Password?
                        </a>


                    </div>


                    <button

                        type="submit"

                        className="btn login-btn w-100"

                        disabled={loading}

                    >

                        {
                            loading
                                ? "Logging in..."
                                : "Login"
                        }

                    </button>


                </form>


            </div>

          </div>

        </>
    );

}

export default Login;

